<template>
  <div class="app">
    <!-- Global Toast Component -->
    <ToastNotification />
    <GlobalConfirmationModal />
    
    <!-- Render Vue Router's <router-view> to handle dynamic component rendering -->
    <router-view></router-view>
  </div>
</template>

<script>
import ToastNotification from '@/components/Toast/toast.vue'
import GlobalConfirmationModal from '@/components/Toast/ConfirmationModal.vue'

export default {
  name: 'App',
  components: {
    ToastNotification,
    GlobalConfirmationModal
  }
};
</script>